import Bugsnag from "@bugsnag/js";
import React from "react";

const ErrorBoundary =
  Bugsnag.getPlugin("react")?.createErrorBoundary(React) || React.Fragment;

export default ErrorBoundary;
